$(document).on 'turbolinks:load', ->
  $('#js-create-occurrence-button').tooltip('enable')
  $('.js-dropzone-upload-link').addClass('hide')
  $('.js-dropzone-success-button').removeClass('hide')